/* The wine pages' comparison table. Scrolls sideways inside its own box on a
   phone so the page itself never does. */

.scroller {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 10px 12px;
  text-align: left;
  vertical-align: top;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

.table thead th {
  white-space: nowrap;
}

.titleCell {
  min-width: 220px;
}

.nowrap {
  white-space: nowrap;
}

.number {
  text-align: right !important;
  white-space: nowrap;
}

/* Phones (Breakpoints.sm=640): narrower title column and tighter cells, so
   duration and format sit on screen next to the title before any swipe. */
@media (max-width: 639px) {
  .table {
    min-width: 520px;
  }

  .table th,
  .table td {
    padding: 8px;
  }

  .titleCell {
    min-width: 160px;
  }
}
